import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { useToast } from "../hooks/use-toast";
import { Instagram, Mail } from "lucide-react";
import { subscribeNewsletter } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { TX } from "../data";

const Footer = () => {
  const { t, lang } = useApp();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email || busy) return;
    setBusy(true);
    try {
      const res = await subscribeNewsletter(email);
      const already = res.status === "already_subscribed";
      toast({
        title: "LÉLUNE",
        description: already
          ? (lang === "nl" ? "Je bent al ingeschreven." : "You're already subscribed.")
          : t.subscribed,
      });
      setEmail("");
    } catch (err) {
      toast({
        title: "LÉLUNE",
        description: lang === "nl" ? "Er ging iets mis." : "Something went wrong.",
      });
    } finally {
      setBusy(false);
    }
  };

  const cols = [
    { title: t.footerShop, links: [
      { label: "Color Lip Tint", to: "/product/color-lip-tint" },
      { label: "Lip Liner", to: "/product/lipliner" },
      { label: "Copper Peptide Serum", to: "/product/copper-peptide-serum-30ml" },
      { label: TX[lang].navShade, to: "/shade-finder" },
    ] },
    { title: t.footerHelp, links: [
      { label: "FAQ", to: "/faq" },
      { label: TX[lang].shippingLine, to: "/faq" },
      { label: "Contact", to: "/faq" },
    ] },
    { title: t.footerAbout, links: [
      { label: t.navAbout, to: "/about" },
      { label: TX[lang].ingredients, to: "/product/copper-peptide-serum-30ml" },
    ] },
  ];

  return (
    <footer className="bg-[#3A2C28] text-[#E9D8CF]">
      <div className="max-w-[1400px] mx-auto px-5 pt-16 pb-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <p className="font-serif text-3xl tracking-brand">LÉLUNE</p>
            <p className="mt-4 text-sm text-[#C4ABA0] max-w-xs leading-relaxed">{t.footerTag}</p>
            <form onSubmit={subscribe} className="mt-7 max-w-sm">
              <p className="text-[11px] tracking-label uppercase text-[#C9A99B] mb-3">{t.newsletter}</p>
              <div className="flex items-center gap-2">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t.emailPlaceholder}
                  className="flex-1 h-11 px-4 rounded-full bg-[#4A3A34] border border-[#5A473F] text-sm text-[#F4E6DE] placeholder:text-[#9C8177] focus:outline-none focus:border-[#E3A99A]"
                />
                <button
                  type="submit"
                  disabled={busy}
                  className="h-11 px-5 rounded-full bg-[#E3A99A] text-[#3A2C28] text-[11px] tracking-label uppercase hover:bg-[#F4E6DE] disabled:opacity-70"
                >
                  {t.subscribe}
                </button>
              </div>
            </form>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <p className="text-[11px] tracking-label uppercase text-[#C9A99B]">{c.title}</p>
              <ul className="mt-4 space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <span
                      onClick={() => navigate(l.to)}
                      className="text-sm text-[#D4BEB3] hover:text-[#F4E6DE] cursor-pointer link-underline"
                    >
                      {l.label}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-6 border-t border-[#5A473F] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[11px] tracking-label uppercase text-[#A6897C]">
            © {new Date().getFullYear()} LÉLUNE · EJ Trading · lelune.nl · {t.rights}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" aria-label="Instagram" className="text-[#C4ABA0] hover:text-[#E3A99A]">
              <Instagram className="h-5 w-5" />
            </a>
            <a href="#" aria-label="Mail" className="text-[#C4ABA0] hover:text-[#E3A99A]">
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
